import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import Input from "../../components/Input";
import GridTable from "../../components/GridTable";
import { useDispatch, useSelector } from "react-redux";
import {
  getDepartment,
  departmentState,
} from "./departmentSlice";
import { getDesignation } from "../designation/designationSlice";
import { formatDateToDDMMYYYY, showMessage } from "../../uitls/Utils";
import Swal from "sweetalert2";
import {
  createDepartment,
  deleteDepartment,
  updateDepartment,
  getAllDepartment,
  uploadBunchDepartment,
} from "../../api/departmentApi";
import { getAllDesignation } from "../../api/designationApi";

import { DialogCustomAnimation } from "../../components/dialog";
import Loader from "../../components/Loader";
import { Button } from "../../components/Button";
import { Select } from "@mui/material";
import Dropdown from "../../components/Dropdown";


const columns = [
  {
    field: "departmentName",
    headerName: "Business Unit",
    width: 200,
    headerClassName: "super-app-theme--header",
  },
 
  {
    field: "designations",
    headerName: "Job Title",
    width: 200,
    headerClassName: "super-app-theme--header",
  },
  {
    field: "createdDate",
    headerName: "Created Date",
    width: 200,
    headerClassName: "super-app-theme--header",
  },
  {
    field: "updatedDate",
    headerName: "Updated Date",
    width: 200,
    headerClassName: "super-app-theme--header",
  },
];

export default function Department() {
  const dispatch = useDispatch();
  const allDepartments = useSelector(getDepartment);
  const stateOfDepartment = useSelector(departmentState);
  const allDesignation = useSelector(getDesignation);

  const [formErrors, setFormErrors] = useState({});
  const [formValues, setFormValues] = useState({
    departmentName: "",
    designation: [],
    designationTitle:""
  });
  const [designations, setDesignations] = useState([]);
  const [rows, setRows] = useState([]);

  const [type, setType] = useState(false);
  const [edit, setEdit] = useState();
  

  useEffect(() => {
    dispatch(getAllDesignation());
    dispatch(getAllDepartment());
  }, [dispatch]);

  useEffect(() => {
    const designationsData = allDesignation.map((ele) => ({
      value: ele?.id,
      label: ele?.name,
    }));
    setDesignations(designationsData);
  }, [allDesignation]);

  useEffect(() => {
    if (Array.isArray(allDepartments)) {
      const formattedRows = allDepartments.map((department, index) => ({
        id: department?.id,
        departmentName: department?.departmentName,
        active: department?.active ? "Yes" : "No",
        createdDate: formatDateToDDMMYYYY(department?.createdDate),
        updatedDate: formatDateToDDMMYYYY(
          department?.updatedDate || department?.createdDate
        ),
        designations: Array.isArray(department?.designations)
          ? department?.designations.map((d) => d.name).join(", ")
          : "No designations",
      }));
      setRows(formattedRows);
    }
  }, [allDepartments]);

  const resetStates = () => {
    setFormValues({ departmentName: "", designation: [] });
    setFormErrors({});
    setEdit(false);
    setType(false);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormValues((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
    setFormErrors((prevErrors) => ({
      ...prevErrors,
      [name]: value ? "" : "Required Field",
    }));
  };



  const validateForm = () => {
    const errors = {};
    if (
      !formValues?.departmentName ||
      formValues?.departmentName === "" ||
      formValues?.departmentName?.trim() === ""
    ) {
      errors["Business Unit Name"] = "Business Unit name is required";
    }
    if (!formValues?.designation || formValues?.designation.length === 0) {
      errors["designation"] = "Designation is required";
    }
    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const trimObjectValues = (obj) => {
    if (Array.isArray(obj)) {
      return obj.map(trimObjectValues);
    } else if (typeof obj === "object" && obj !== null) {
      return Object.keys(obj).reduce((acc, key) => {
        acc[key] = trimObjectValues(obj[key]);
        return acc;
      }, {});
    } else if (typeof obj === "string") {
      return obj.trim();
    }
    return obj;
  };

  const handleSubmitDepartment = () => {
    if (validateForm()) {
      const { departmentName, designation } = formValues;
      if(designation?.length==0){
        showMessage({title:"Please enter designation"})
      }
      const selectedDesignations = designation.map((item) => ({
        id: item?.value==item?.label?null:item?.value,
        name: item?.label,
      }));

      const data = { departmentName, designations: selectedDesignations };

      if (edit) {
        dispatch(
          updateDepartment({
            id: edit,
            data: trimObjectValues(data),
          })
        )
          .unwrap()
          .then(() => {
            resetStates();
          })
          .catch((error) => {
          
            // Swal.fire({
            //   title: "Error!",
            //   text: "Failed to update Business Unit. Please try again.",
            //   icon: "error",
            //   confirmButtonColor: "#dc2626",
            //   customClass: {
            //     popup: "custom-swal-width",
            //     icon: "custom-swal-icon",
            //     title: "custom-swal-title",
            //     content: "custom-swal-content",
            //   },
            // });
          });
      } else {
        dispatch(createDepartment(trimObjectValues(data)))
          .unwrap()
          .then(() => {
            resetStates();
          })
          .catch((error) => {
     
            // Swal.fire({
            //   title: "Error!",
            //   text: "Failed to add Business Unit. Please try again.",
            //   icon: "error",
            //   confirmButtonColor: "#dc2626",
            //   customClass: {
            //     popup: "custom-swal-width",
            //     icon: "custom-swal-icon",
            //     title: "custom-swal-title",
            //     content: "custom-swal-content",
            //   },
            // });
          });
      }
    }
  };

  const handleDelete = (id) => {
    Swal.fire({
      titleText: "Delete Business Unit ?",
      text: "Are you sure want to delete this business unit?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#dc2626", // Red for destructive action
      cancelButtonColor: "#3C50E0", // Primary color for cancel
      confirmButtonText: "Delete",
      cancelButtonText: "Cancel",
      customClass: {
        popup: "custom-swal-width", // Custom width of the popup
        icon: "custom-swal-icon", // Custom icon size
        title: "custom-swal-title", // Custom title size
        content: "custom-swal-content", // Custom content (text) size
      },
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(deleteDepartment(id))
          .unwrap()
          .then(() => {
          })
          .catch((error) => {
            console.log(error);
            Swal.fire({
              title: "Error!",
              text: "Failed to delete Business Unit. Please try again.",
              icon: "error",
              confirmButtonColor: "#dc2626",
              customClass: {
                popup: "custom-swal-width",
                icon: "custom-swal-icon",
                title: "custom-swal-title",
                content: "custom-swal-content",
              },
            });
          });
      }
    });
  };

  const handleCancelClick = () => {
    resetStates();
  };

  const handleUpdate = (id) => {
    const departmentToEdit = allDepartments.find(
      (department) => department.id === id
    );
    if (departmentToEdit) {
      setFormValues({
        departmentName: departmentToEdit.departmentName,
        designation: departmentToEdit.designations.map((d) => ({
          value: d.id,
          label: d.name,
        })),
      });
      setEdit(departmentToEdit.id);
      setType(true);
    }
  };
  const handleCheckboxChange = (event) => {
    const { value, checked } = event.target;
    const selectedOption = designations?.find(
      (option) => option.value === value
    );

    let updatedDesignations = [...formValues.designation];

    if (checked) {
      updatedDesignations.push({ label: selectedOption.label, value: value });
    } else {
      updatedDesignations = updatedDesignations?.filter(
        (designation) => designation.value !== value
      );
    }

    setFormValues((prevValues) => ({
      ...prevValues,
      designation: updatedDesignations,
    }));
  };
  const onClickAction = (actions, rows) => {
    if (actions === "EDIT") {
      handleUpdate(rows.id);
    } else if (actions === "DELETE") {
      handleDelete(rows.id);
    }
  };

  const handleSave = () => {
    handleSubmitDepartment();
  };
  const handleClose = () => {
    handleCancelClick();
  };
  const handleDropdownChange=({value,label})=>{
    let updatedDesignations = [...formValues.designation];

    const selectedOption = updatedDesignations?.find(
      (option) => option.value === value
    );
    if (!selectedOption) {
      updatedDesignations.push({ label: label, value: value });
    } else {
      updatedDesignations = updatedDesignations?.filter(
        (designation) => designation.value !== value
      );
    }

    setFormValues((prevValues) => ({
      ...prevValues,
      designation: updatedDesignations,
    }));

  }
  const _addDesignattionTitle=()=>{
    if(formValues.designationTitle.trim()?.length==0){
      return
    }
   const index= formValues.designation.findIndex((e)=>(e.label==formValues.designationTitle))
   if(index==-1){

    setFormValues((prevValue)=>({
       ...prevValue,
      designation: [...formValues.designation,{label:formValues.designationTitle,value:formValues.designationTitle}],
      designationTitle:""
    }))
   } 
  
  }

// const _onCsvUpload=(file)=>{

//    const formData = new FormData();

//       if (file && file instanceof File) {
//         formData.append("file", file);
//       }
//       dispatch(
//         uploadBunchDepartment({
//           values: formData,
//         })
//       )
//         .unwrap()
//         .then((result) => {
//           if(result.status===200){
//             showMessage({title:result?.message,})
//           }
//           console.log(result)
//         })
        

// }


  const _onCsvUpload=async(file)=>{
  
     const formData = new FormData();
        if (file && file instanceof File) {
          formData.append("file", file);
        }
          try {
      const result = await dispatch(uploadBunchDepartment(formData)).unwrap();
      Swal.fire({
        icon: "success",
       
        text: result?.message || "Upload successful",
        timer: 2000,
        showConfirmButton: false,
      });
      // Refresh the employee list
      dispatch(getAllDepartment());
    } catch (e) {
      Swal.fire({
        icon: "error",
        title: "Import failed",
        text: e?.message || "Something went wrong",
      });
  }

}


  return (
    <div className="pt-4 md:pt-6 2xl:pt-10 w-full px-4 md:px-6 lg:px-8">
      {stateOfDepartment?.loading && <Loader />}
      <GridTable
        onClickAction={onClickAction}
        actions={["DELETE", "EDIT"]}
        rowData={rows}
        columnData={columns}
        toolTipName={"Add Business Unit"}
        onClickAdd={() => {
          setType(true);
        }}
        templateName="Department"
        onCsvUpload={_onCsvUpload}
      />

      <DialogCustomAnimation
        open={type}
        handleClose={handleClose}
        // title="Delete Department?"
        // message={"message"}
        // size="sm"
        header={edit ? "Update Business Unit" : "Add Business Unit"}
        handleSave={handleSave}
        // handleDelete={handleDelete}
        size="md"
        body={
          <div className="w-full space-y-6">
            {/* Department Information Section */}
            <div className="space-y-4">
              <div className="flex items-center gap-3 mb-4">
                <div className="p-3 bg-blue-50 rounded-lg">
                  <svg
                    className="w-5 h-5 text-blue-600"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
                    />
                  </svg>
                </div>
                <div>
                  <h3 className="text-base font-semibold text-gray-800">
                    Business Unit Information
                  </h3>
                  <p className="text-sm text-gray-600">
                    Enter the business unit details
                  </p>
                </div>
              </div>

              <Input
                name="departmentName"
                placeholder="Enter Business Unit Name"
                value={formValues?.departmentName || ""}
                onChange={handleInputChange}
                label="Business Unit Name"
                requiredField={true}
                error={formErrors?.departmentName || ""}
              />
 
            </div>
            
            <div className="flex flex-row items-center gap-3  ">
                <Input
                name="designationTitle"
                placeholder="Designation Title"
                value={formValues?.designationTitle || ""}
                onChange={handleInputChange}
                label="Designation Title"
                requiredField={false}
                className={"!w-[400px]"}
                error={formErrors?.designationTitle || ""}
                
              
              />
              <Button value="Add" className="!h-12 mt-1" handleClick={_addDesignattionTitle}>Add</Button>
              </div>
              
                 {/* <div className="max-w-sm">
                          <Dropdown
                            submitRef={true}
                            defaultValue={formValues?.designation?.reverse() || null}
                            options={designations}
                            handleChange={(e)=>handleDropdownChange(e)}
                            errorMessage={formErrors?.designation}
                            requiredField={false}
                            defaultLabel="Select Designation Title"
                            label="Select Designation From Master List"
                            className="h-[39px]"
                            
                          />
                        </div> */}

            {/* Job Titles Section */}
            <div className="space-y-4">
              <div className="flex items-center gap-3 mb-4">
                <div className="p-3 bg-green-50 rounded-lg">
                  <svg
                    className="w-5 h-5 text-green-600"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2-2v2m8 0V6a2 2 0 012 2v6a2 2 0 01-2 2H8a2 2 0 01-2-2V8a2 2 0 012-2V6"
                    />
                  </svg>
                </div>
                <div>
                  <h3 className="text-base font-semibold text-gray-800">
                    Associated Job Titles
                  </h3>
                  <p className="text-sm text-gray-600">
                    Select job titles for this business unit
                  </p>
                </div>
              </div>

              <div className="bg-gradient-to-br from-gray-50 via-white to-gray-50 rounded-xl p-5 max-h-48 overflow-y-auto shadow-sm">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                  {formValues?.designation.map((option, index) => {
                    const isChecked = formValues.designation.some(
                      (designation) => designation.value === option.value
                    );
                    return (
                      <motion.label
                        key={option.value}
                        initial={{ opacity: 0, y: 10 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: index * 0.05 }}
                        whileHover={{ scale: 1.02, x: 4 }}
                        className={`
                          flex items-center gap-3 p-3 rounded-lg transition-all duration-300
                          ${isChecked 
                            ? "bg-gradient-to-r from-blue-50 to-blue-100 shadow-md hover:shadow-lg" 
                            : "bg-white shadow-sm hover:bg-gradient-to-r hover:from-gray-50 hover:to-blue-50 hover:shadow-md"
                          }
                        `}
                      >
                        <div className="relative">
                          <input
                            type="checkbox"
                            id={option.value}
                            name={option?.name}
                            value={option.value}
                            checked={isChecked}
                            onChange={handleCheckboxChange}
                            className="sr-only"
                          />
                          <motion.div
                            className={`
                              w-5 h-5 rounded-md flex items-center justify-center transition-all duration-300
                              ${isChecked 
                                ? "bg-gradient-to-br from-[#0b3a5c] to-[#135e96] shadow-lg" 
                                : "bg-white shadow-md hover:shadow-lg hover:shadow-blue-200/50"
                              }
                            `}
                            whileHover={{ scale: 1.1 }}
                            whileTap={{ scale: 0.9 }}
                          >
                            {isChecked && (
                              <motion.svg
                                initial={{ scale: 0 }}
                                animate={{ scale: 1 }}
                                className="w-3.5 h-3.5 text-white"
                                fill="none"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="3"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                              >
                                <path d="M5 13l4 4L19 7"></path>
                              </motion.svg>
                            )}
                          </motion.div>
                        </div>
                        <span className={`
                          text-sm font-medium transition-colors duration-300
                          ${isChecked 
                            ? "text-[#135e96] font-semibold" 
                            : "text-gray-700"
                          }
                        `}>
                          {option.label}
                        </span>
                      </motion.label>
                    );
                  })}
                </div>
                {formErrors?.designation && (
                  <div className="mt-3 text-sm text-red-600 flex items-center gap-2">
                    <svg
                      className="w-4 h-4"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path
                        fillRule="evenodd"
                        d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                        clipRule="evenodd"
                      />
                    </svg>
                    {formErrors?.designation}
                  </div>
                )}
              </div>
            </div>
          </div>
        }
      />
    </div>
  );
}
